import React from "react";

import IconButton from '@material-ui/core/IconButton';
import FlipCameraIosOutlinedIcon from '@material-ui/icons/FlipCameraIosOutlined';

import styles from "./CameraViewer.module.css";

function CameraViewer() {

  const errorMsg = "Zugriff auf Kamera nicht möglich";

  const cameraViewer: any = React.useRef<HTMLVideoElement>();
  const init: MediaDeviceInfo[] = [];
  const [cameras, setCameras] = React.useState(init);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [selectedTracks, setSelectedTracks] = React.useState([] as MediaStreamTrack[]);

  const switchCamera = () => {
    let newIndex = selectedIndex + 1;
    if(newIndex >= cameras.length){
      newIndex = 0;
    }
    const device = cameras[newIndex];
    if(device){
      const constraints = { video: { deviceId: device.deviceId } };
      window.navigator.mediaDevices.getUserMedia(constraints)
      .then(stream => {
        const tracks = stream.getTracks();
        setSelectedTracks(tracks);
        cameraViewer.current.srcObject = stream;
        cameraViewer.current.onloadedmetadata = (e: any) => {
          cameraViewer.current.play();
        };
      }, (_) => alert(errorMsg) )
      .catch( (_) => {
        alert(errorMsg);
      });
    }
    setSelectedIndex(newIndex);
  }

  React.useEffect(() => {
    return () => {
      if(selectedTracks){
        selectedTracks.forEach((track) => track.stop());
      }
    }
  }, [selectedTracks])
  

  React.useEffect(() => {
    let s: any = null;
    let viewer = cameraViewer?.current;
    if(cameraViewer){
        window.navigator.mediaDevices.getUserMedia({ video: {facingMode: 'user'}})
        .then(stream => {
            s = stream;
            window.navigator.mediaDevices.enumerateDevices().then((devices) => {
                let videoDevices = devices.filter(d => d.kind === "videoinput");
                setCameras(videoDevices);
                const tracks = stream.getTracks();
                const track = tracks.shift();
                if(track){
                  const setting = track.getSettings();
                  const deviceIndex = videoDevices.findIndex(d => d.deviceId === setting.deviceId);
                  if(deviceIndex > -1){
                    setSelectedIndex(deviceIndex);
                  }
                }
            });
            
            cameraViewer.current.srcObject = stream;
            cameraViewer.current.onloadedmetadata = (e: any) => {
                cameraViewer.current.play();
            };
        }, (_) => alert(errorMsg) )
        .catch( (_) => {
            alert(errorMsg);
        });
    }
    return () => {
      if(s){
        s!.getTracks().forEach((track: any) => track.stop());
      }
      if(viewer){
        viewer.pause();
        viewer.srcObject = null;
      }
    }
  }, [cameraViewer])

  return (
    <div className={styles.CameraViewerContainer}>
        {/* <input type="file" accept="video/*;capture=camcorder"></input> */}
        <video playsInline ref={cameraViewer} muted></video>
        <div className={styles.CameraViewerSwitcher}>
          <div className={'instruction-info-field'}>
                <div className={'instruction-info-back'} style={{
                  }}>
                  <p style={{left: 0, top:25}}>
                    Kamera wechseln
                  </p>
                </div>
                <IconButton  color="inherit" onClick={switchCamera}>
                      <FlipCameraIosOutlinedIcon fontSize="small" color='inherit' />
                </IconButton >
            </div>
        </div>
    </div>
  );
}
export default React.forwardRef(CameraViewer)